import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Sidebar } from './components/layout/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { BackofficeUsers } from './pages/BackofficeUsers';
import { PotentialUsers } from './pages/PotentialUsers';
import { FinancialSimulator } from './pages/FinancialSimulator';
import { CommercialStrategy } from './pages/CommercialStrategy';
import { Contractors } from './pages/Contractors';
import { Documents } from './pages/Documents';
import { WithdrawalForms } from './pages/WithdrawalForms';
import { Integrations } from './pages/Integrations';
import { Parameters } from './pages/Parameters';
import { Settings } from './pages/Settings';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-gray-50" data-id="element-1">
        <Navbar data-id="element-2" />
        <Sidebar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
          <Route path="/dashboard" element={<Dashboard data-id="element-8" />} data-id="element-7" />
          <Route path="/users" element={<Users data-id="element-10" />} data-id="element-9" />
          <Route path="/backoffice-users" element={<BackofficeUsers data-id="element-12" />} data-id="element-11" />
          <Route path="/field-users" element={<Users data-id="element-14" />} data-id="element-13" />
          <Route path="/potential-users" element={<PotentialUsers data-id="element-16" />} data-id="element-15" />
          <Route path="/financial-simulator" element={<FinancialSimulator data-id="element-18" />} data-id="element-17" />
          <Route path="/commercial-strategy" element={<CommercialStrategy data-id="element-20" />} data-id="element-19" />
          <Route path="/financial-plans" element={<CommercialStrategy data-id="element-22" />} data-id="element-21" />
          <Route path="/contractors" element={<Contractors data-id="element-24" />} data-id="element-23" />
          <Route path="/documents" element={<Documents data-id="element-26" />} data-id="element-25" />
          <Route path="/withdrawal-forms" element={<WithdrawalForms data-id="element-28" />} data-id="element-27" />
          <Route path="/reports" element={<Dashboard data-id="element-30" />} data-id="element-29" />
          <Route path="/integrations" element={<Integrations data-id="element-32" />} data-id="element-31" />
          <Route path="/settings" element={<Settings data-id="element-34" />} data-id="element-33" />
        </Routes>
      </div>
    </BrowserRouter>;
}